import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import './hideBadge.css';
import LandingPage from './pages/LandingPage';
import ThankYouPage from './pages/ThankYouPage';
import AdminPage from './pages/AdminPage';
import { robustPost } from './lib/robustFetch';
import { flushLeadQueue } from './lib/leadQueue';

// Analytics tracking component
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        // Persistent session ID — unique visitor tracking
        let sessionId = localStorage.getItem('ale_session_id');
        if (!sessionId) {
          sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
          localStorage.setItem('ale_session_id', sessionId);
        }
        await robustPost('/api/analytics', {
          event_type: 'page_view',
          page: location.pathname,
          metadata: {
            session_id: sessionId,
            referrer: document.referrer,
            userAgent: navigator.userAgent,
          },
        });
      } catch (error) {
        // Silent — tracker must never block the UI.
      }
    };

    trackPageView();
  }, [location]);

  return null;
}

function App() {
  // On app load, flush any leads that failed to send previously (offline / network errors).
  useEffect(() => {
    flushLeadQueue();
  }, []);

  return (
    <Router>
      <AnalyticsTracker />
      {/* Noise overlay for texture */}
      <div className="noise-overlay" aria-hidden="true" />

      <div className="relative z-10">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
